import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { Card } from "@bezbolisno/ui/card";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageHeader } from "../../../components/page-header";
import { api, expectOk } from "../../../lib/api";
import { keys } from "../../../lib/keys";
import { AnalyticsView } from "../../../screens/analytics/analytics-view";

const analyticsQuery = queryOptions({
  queryKey: keys.analytics,
  queryFn: async () => expectOk(await api.readModels.analytics({}), 200),
});

/** Clinical statistics — managers are bounced to the dashboard (the API also answers 403). */
export const Route = createFileRoute("/_authed/analytics/")({
  beforeLoad: ({ context }) => {
    if (!can(context.session.role, "clinical:read")) throw redirect({ to: "/" });
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(analyticsQuery),
  component: AnalyticsPage,
});

function AnalyticsPage() {
  const { data, isError } = useQuery(analyticsQuery);
  if (isError || !data) {
    return (
      <div className="fade-in">
        <PageHeader title={t.nav.analytics} />
        <Card className="p-5 text-sm text-[color:var(--muted)]">{t.analytics.dbError}</Card>
      </div>
    );
  }
  return <AnalyticsView data={data} />;
}
